export default __webpack_public_path__ + "static/ppq-modal-images-5791680b46caacd9d929fc24878d24e3.png";